import { store } from '../kastjs/event-bus';
import { hostMap, PROTAL_URL_ENUM } from './config';

import type { InnerOptions } from './types';

type GlobalStore = Pick<
  InnerOptions,
  | 'env'
  | 'userData'
  | 'gatewayUrl'
  | 'systemId'
  | 'currentSubSystemName'
  | 'source'
  | 'isKimLeftSideBar'
>;

function addShare(valueMap: Record<string, any>): void {
  for (const key in valueMap) {
    if (valueMap.hasOwnProperty(key)) {
      // @ts-ignore
      window[key] = valueMap[key];
    }
  }
}

export type StoreKey<T extends Record<string, any> = {}> = keyof (GlobalStore & T);

export class Store {
  private KEY = 'CRM_PLUGIN_RUNTIME';
  private USER_KEY = 'CRM_PLUGIN_RUNTIME_USER';

  isExist() {
    return !!store.get(this.KEY);
  }

  get<T extends Record<string, any> = {}>(key: keyof (T & GlobalStore)) {
    const store = this.getAll<T>();
    return store?.[key];
  }

  getAll<T extends Record<string, any> = {}>(): T & GlobalStore {
    const data: GlobalStore = store.get(this.KEY);
    const userOptions: T = store.get(this.USER_KEY) || {};
    const env = data?.env || hostMap[window.location.host]?.env || 'local';
    const source = data?.source || hostMap[window.location.host]?.type || 'unknown';
    const gatewayUrl = data?.gatewayUrl || PROTAL_URL_ENUM[env];
    return { ...userOptions, ...data, env, gatewayUrl, source };
  }

  setAll(options: InnerOptions) {
    const userData = {
      ...options.userData,
      userId: options.userData?.ksUserId,
      realName: options.userData?.name,
      userName: options?.userData?.email,
    };

    // 保持引用地址不变
    const globalLcdpStore = (window as any).globalLcdpStore || {};
    globalLcdpStore.userData = userData;
    globalLcdpStore.subSystemName = options.currentSubSystemName;
    globalLcdpStore.baseUrl = options.gatewayUrl;
    globalLcdpStore.userInfo = userData;

    const __CRM_GLOBAL_STORE = (window as any).__CRM_GLOBAL_STORE || {};
    __CRM_GLOBAL_STORE.env = options.env;
    __CRM_GLOBAL_STORE.userData = userData;
    __CRM_GLOBAL_STORE.gatewayUrl = options.gatewayUrl;
    __CRM_GLOBAL_STORE.systemId = options.systemId;
    __CRM_GLOBAL_STORE.currentSubSystemName = options.currentSubSystemName;
    __CRM_GLOBAL_STORE.source = options.source;

    addShare({
      // 兼容之前的标准
      globalLcdpStore,
      globalBaseUrl: options.gatewayUrl,
      // 新标准
      __CRM_GLOBAL_STORE,
    });
    // 财神需要
    store.set('crmGlobalProps', {
      userInfo: userData,
      userData,
      isCrmMicroApp: hostMap[window.location.host]?.type === 'crm',
      subSystemName: options.currentSubSystemName,
    });
    // 门户需要
    store.set('userData', userData);

    store.set(this.KEY, {
      env: options.env,
      userData: userData,
      gatewayUrl: options.gatewayUrl,
      systemId: options.systemId,
      currentSubSystemName: options.currentSubSystemName,
      source: options.source,
    } as GlobalStore);
  }

  setUser(options: Record<string, any>) {
    let originOptions = store.get(this.USER_KEY);
    if (!originOptions || typeof originOptions !== 'object') {
      originOptions = {};
    }
    store.set(this.USER_KEY, { ...originOptions, ...options });

    // 兼容财神代码
    let crmGlobalProps = store.get('crmGlobalProps');
    if (!crmGlobalProps || typeof crmGlobalProps !== 'object') {
      crmGlobalProps = {};
    }
    store.set('crmGlobalProps', { ...crmGlobalProps, ...options });
  }

  clear() {
    /** 清空CRM 全局权限 */
    // @ts-ignore
    window['_lingoUpmPermissions'] = undefined;
    instance.setUser({ upmInstance: undefined });

    return !!store.set(this.KEY, null);
  }
}

export const instance: Store = new Store();
